define([
], function () {

  function SourceInfo(model, channels) {
    this.model = model;
    this.channels = channels;
  }

  SourceInfo.prototype._isServiceAvailable = function (model, id) {
    var that = this;
    var sources = model.get("sources.sources");
    if (!sources) {
      return false;
    }
    var channelUrl = that.channels.at(0).get('url');
    var services = sources[channelUrl] && sources[channelUrl].services;
    var hasService;
    hasService = (services &&
                  services.length &&
                  services.find(function (service) { return service.id === id }) != null) || false;
    return hasService;
  }

  SourceInfo.prototype.isServiceAvailable = function (id) {
    return this._isServiceAvailable(this.model, id);
  }
  
  SourceInfo.prototype.isServiceAvailableAsync = function (id) {
    var that = this;
    return this.model.updated().then(function (model) {
      return that._isServiceAvailable(model, id);
    });
  }

  return SourceInfo;
});
